import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Services from "./Services";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> C++, Javascript and python. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Blockchain.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        
        {/* Services Section */}
        <Services />

        {/* OpenToWork Section - Now After Services */}
        <Row className="mt-5">
          <Col md={6} className="professional-experience-section">
            

            <div className="availability-section" style={{ marginTop: "30px" }}>
              <h2 className="purple" style={{ fontWeight: "bold" }}>#OpenToWork</h2>
              <h3 style={{ color: "white" }}>Need a Platform Engineer?</h3>
              
              <p className="home-about-body" style={{ marginTop: "20px", color: "white" }}>
                I provide freelance services in software development, system architecture, code optimization. 
                With extensive experience in various technologies, I can deliver high-quality, scalable solutions 
                tailored to your business needs.
              </p>
              
              <p className="home-about-body" style={{ marginTop: "15px", color: "white" }}>
                Let's collaborate to bring your projects to life.
              </p>
              
              <button 
                onClick={() => window.location.href = "/contact"} 
                className="btn primary-btn" 
                style={{ 
                  background: "linear-gradient(135deg, rgba(137, 43, 226, 0.8), rgba(87, 43, 226, 0.9))",
                  color: "white",
                  padding: "12px 25px",
                  borderRadius: "30px",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  border: "none",
                  marginTop: "15px",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "linear-gradient(135deg, rgba(157, 63, 246, 0.9), rgba(107, 63, 246, 1))";
                  e.target.style.transform = "translateY(-3px)";
                  e.target.style.boxShadow = "0 10px 20px rgba(87, 43, 226, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "linear-gradient(135deg, rgba(137, 43, 226, 0.8), rgba(87, 43, 226, 0.9))";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Get in touch
              </button>
            </div>
          </Col>
          
          <Col md={6} className="d-flex align-items-center justify-content-center">
            <div className="professional-highlight-image" style={{ 
              backgroundColor: "rgba(31, 31, 50, 0.8)",
              borderRadius: "15px",
              border: "1.5px solid rgba(137, 43, 226, 0.4)",
              padding: "30px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              width: "100%",
              maxWidth: "400px"
            }}>
              <div style={{ 
                fontSize: "3em", 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                flexDirection: "column",
                color: "white"
              }}>
                <div style={{ color: "#c084f5", marginBottom: "20px", fontSize: "4rem" }}>💼</div>
                <div style={{ fontSize: "0.5em", textAlign: "center" }}>Experienced Platform Engineer</div>
                <div style={{ fontSize: "0.4em", color: "#c084f5", marginTop: "10px" }}>Ready for new challenges</div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple" onClick={() => window.location.href = "/contact"} style={{ cursor: "pointer" }}>connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/marwaniiwael18"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/World.Wide.Server08/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/wael-marwani-/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/waeel_marouanii/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
